import classnames from 'classnames'

import css from './buttons.module.scss'

const cx = classnames.bind(css)

export const DefaultButton = ({ children, ...rest }) => (
  <button className={cx(css.Button, css.defaultButton)} {...rest}>
    {children}
  </button>
)

export const GreenButton = ({ children, ...rest }) => (
  <button className={cx(css.Button, css.greenButton)} {...rest}>
    {children}
  </button>
)

export const RedButton = ({ children, ...rest }) => (
  <button className={cx(css.Button, css.redButton)} {...rest}>
    {children}
  </button>
)
